import { columnWidths } from './columnWidths';

export const drawerWidths = {
  col4: columnWidths.col4,
  col5: columnWidths.col5,
  col6: columnWidths.col6,
  col7: columnWidths.col7,
  col8: columnWidths.col8,
  col9: columnWidths.col9,
  col10: columnWidths.col10,
  col11: columnWidths.col11,
  col12: columnWidths.col12,
  col13: columnWidths.col13,
  col14: columnWidths.col14,
} as const;

export type DrawerWidth = keyof typeof drawerWidths;
